import prettyCron from 'prettycron';
import later from 'later';
import moment from 'moment';
import zeropad from 'zeropad';

const numberList = (numbers) => {
  const andString = 'and';
  if (numbers.length < 2) {
    return moment().localeData().ordinal(numbers);
  }
  const lastVal = numbers.pop();
  return `${numbers.join(', ')} ${andString} ${moment().localeData().ordinal(lastVal)}`;
};

const numberToDateName = (value, type) => {
  if (type === 'dow') {
    return moment().day(value - 1).format('ddd');
  } else if (type === 'mon') {
    return moment().month(value - 1).format('MMM');
  }
  return '';
};

const dateList = (numbers, type) => {
  const andString = 'and';

  if (numbers.length < 2) {
    return numberToDateName(numbers[0].toString(), type);
  }

  const lastVal = numbers.pop().toString();
  let outputText = '';

  for (let i = 0; i < numbers.length; i++) {
    const value = numbers[i];
    if (outputText.length > 0) {
      outputText += ', ';
    }
    outputText += numberToDateName(value, type);
  }
  return outputText + andString + numberToDateName(lastVal, type);
};

const scheduleToSentence = (schedule, cronspec) => {
  const acs = cronspec.split(' ');
  const everyMonthString = 'every month';
  const everyDayString = 'every day';
  const everyHourString = 'every hour';
  const ontheString = 'on the';
  const hourOnTheHour = 'hour, on the hour';
  const minutesOfString = 'minutes of';
  const minutePastEveryHourString = 'minutes past every hour';
  const minutePastString = 'minute past';
  const minuteString = 'minute';
  const hourString = 'hour';
  const inString = 'in';
  const onString = 'on';
  const andEveryString = 'and every';
  const andString = 'and';

  let outputText = '';

  if (schedule.h && schedule.m && schedule.h.length <= 2 && schedule.m.length <= 2) {
    const hm = [];
    for (let i = 0; i < schedule.h.length; i++) {
      for (let j = 0; j < schedule.m.length; j++) {
        hm.push(`${zeropad(schedule.h[i])}:${zeropad(schedule.m[j])}`);
      }
    }
    if (hm.length < 2) {
      outputText = hm[0];
    } else {
      const lastVal = hm.pop();
      outputText = `${hm.join(', ')} ${andString} ${lastVal}`;
    }
    if (!schedule.d && !schedule.D) {
      outputText += ` ${everyDayString}`;
    }
  } else if (schedule.h) { // runs only at specific hours
    if (schedule.m) { // and only at specific minutes
      outputText += `${numberList(schedule.m)} ${minutePastString} ${numberList(schedule.h)} ${hourString}`;
    } else if (schedule.h.length === 24) {
      outputText += everyHourString;
    } else if (acs[2].match(/(\?|\*)\/[0-9]+$/) !== null) {
      outputText += `${acs[2].replace(acs[2].match(/(\?|\*)\//)[0], '')} ${everyHourString}`;
    } else {
      outputText += `${minutesOfString} ${numberList(schedule.h)} ${hourString}`;
    }
  } else if (schedule.m) { // every hour, but specific minutes
    if (schedule.m.length === 1 && schedule.m[0] === 0) {
      // outputText += 'hour, on the hour';
      outputText += hourOnTheHour;
    } else if (schedule.m.length === 60) {
      outputText += minuteString;
    } else if (acs[1].match(/(\?|\*)\/[0-9]+$/) !== null) {
      outputText += `${acs[1].replace(acs[1].match(/(\?|\*)\//)[0], '')} ${minutePastEveryHourString}`;
    } else {
      outputText += `${numberList(schedule.m)} ${minutePastEveryHourString}`;
    }
  } else { // cronspec has "*" for both hour and minute
    outputText += minuteString;
  }

  if (schedule.D) { // runs only on specific day(s) of month
    outputText += ` ${ontheString} ${numberList(schedule.D)}`;
    if (!schedule.M) {
      outputText += ` ${everyMonthString}`;
    }
  }

  if (schedule.d) { // runs only on specific day(s) of week
    if (schedule.D) {
      outputText += ` ${andEveryString} `;
    } else {
      outputText += ` ${onString} `;
    }
    outputText += dateList(schedule.d, 'dow');
  }

  if (schedule.M) {
    outputText += ` ${inString}  ${dateList(schedule.M, 'mon')}`;
  }
  return outputText;
};

prettyCron.toString = (cronspec) => {
  const newCronText = cronspec[0] === ' ' ? cronspec.substring(1, cronspec.length) : cronspec;
  const schedule = later.parse.cron(newCronText, 6);
  return scheduleToSentence(schedule.schedules[0], newCronText);
};

export default prettyCron;



// WEBPACK FOOTER //
// ./src/utils/prettycronOverride.js